import { html } from "lit-element";
import { StofwarePageElement } from "@stofloos/core/base/sw-page-element/index";
import { style } from "./style";
import { LayoutFlex } from "@stofloos/globals/styles/layout-flex";

export class StofwareTemplateSplit extends StofwarePageElement {
	static get styles() {
		return [LayoutFlex, style];
	}
	static get properties() {
		return {
			logo: String
		};
	}
	render() {
		let template;
		if (
			window.innerWidth < 780 ||
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
		) {
			template = html`
				<div class="layout horizontal">
					<div class="column left layout flex vertical"></div>
					<div class="column right flex layout vertical center-center justified">
						<div class="inner">
							<img style="margin-left: 0; margin-top:10px;" src="${this.logo}" />
							<slot name="left"></slot>
							<slot name="right"></slot>
						</div>
					</div>
				</div>
			`;
		} else {
			template = html`
				<div class="layout horizontal">
					<div class="column left layout flex vertical">
						<slot name="left"></slot>
					</div>
					<div class="column right flex layout vertical center-center justified">
						<div class="inner">
							<img style="margin-bottom: 20px;" src="${this.logo}" />
							<slot name="right"></slot>
						</div>
					</div>
				</div>
			`;
		}
		return html`
			${template}
		`;
	}
}

window.customElements.define("sw-template-split", StofwareTemplateSplit);
